// extracted by mini-css-extract-plugin
export default {"avatar":"Style_avatar__DVxS0","truncateTitle":"Style_truncateTitle__zmDOn","progressBar":"Style_progressBar__z4vBu"};